// AutoSaveManager.js - 防抖自动存档
import DebugHelper from './DebugHelper.js';
import SaveSystem from './SaveSystem.js';
import { emitAutoSaveStatus } from './AutoSaveToast.js';
import { GAME_CONSTANTS } from './GameConstants.js';

class AutoSaveManagerClass {
    constructor() {
        this.debounceTimer = null;
        this.lastSaveTime = 0;
        this.pending = false;
        this.periodicTimer = null;
    }

    /**
     * 防抖调度存档（战斗胜利、切场景等）
     * @param {string} reason
     */
    scheduleSave(reason = 'auto') {
        if (!window.userInfo?.userId) {
            return;
        }

        this.pending = true;

        if (this.debounceTimer) {
            clearTimeout(this.debounceTimer);
        }

        this.debounceTimer = setTimeout(() => {
            this.debounceTimer = null;
            this.saveNow(reason);
        }, GAME_CONSTANTS.AUTO_SAVE.DEBOUNCE_MS);
    }

    /**
     * 立即尝试存档
     * @param {string} reason
     * @returns {Promise<boolean>}
     */
    async saveNow(reason = 'manual') {
        if (!window.userInfo?.userId) {
            return false;
        }

        const now = Date.now();
        if (now - this.lastSaveTime < GAME_CONSTANTS.AUTO_SAVE.MIN_INTERVAL_MS) {
            DebugHelper.log(`AutoSave: 跳过（间隔过短） reason=${reason}`);
            this.pending = false;
            return false;
        }

        this.pending = false;
        DebugHelper.log(`AutoSave: 开始存档 reason=${reason}`);
        const success = await SaveSystem.save(0);
        if (success) {
            this.lastSaveTime = Date.now();
            emitAutoSaveStatus('已自动保存', true);
        } else {
            emitAutoSaveStatus('自动保存失败', false);
        }
        return success;
    }

    /** 战斗胜利后触发 */
    onBattleVictory() {
        this.scheduleSave('battle_victory');
    }

    /** 场景切换后触发 */
    onSceneTransition() {
        this.scheduleSave('scene_transition');
    }

    /** 启动周期性存档检查 */
    startPeriodicSave() {
        if (this.periodicTimer) {
            return;
        }

        this.periodicTimer = setInterval(() => {
            if (!window.userInfo?.userId) {
                return;
            }
            const elapsed = Date.now() - this.lastSaveTime;
            if (elapsed >= GAME_CONSTANTS.AUTO_SAVE.PERIODIC_MS || this.pending) {
                this.saveNow('periodic');
            }
        }, GAME_CONSTANTS.AUTO_SAVE.PERIODIC_CHECK_MS);
    }

    stopPeriodicSave() {
        if (this.periodicTimer) {
            clearInterval(this.periodicTimer);
            this.periodicTimer = null;
        }
        if (this.debounceTimer) {
            clearTimeout(this.debounceTimer);
            this.debounceTimer = null;
        }
    }
}

const AutoSaveManager = new AutoSaveManagerClass();
export default AutoSaveManager;
